import { Dialog, Box, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import OrderResult from './OrderResult';
import InvoiceResult from './InvoiceResult';

ItemResultDialog.propTypes = {
  searchType: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  searchResult: PropTypes.object,
  search: PropTypes.string,
};

export default function ItemResultDialog({ searchType, open = false, onClose, searchResult, search }) {
  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        onClose();
      }}
      maxWidth="md"
      fullWidth
      sx={{ padding: 2 }}
    >
      <DialogTitle sx={{ textAlign: 'center', position: 'relative' }}>
        Order
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Box sx={{ padding: 2 }}>
        {searchType?.toLowerCase()?.includes('order') ? (
          <OrderResult searchResult={searchResult} searchValue={search} isDialog />
        ) : searchType?.toLowerCase()?.includes('invoice') ? (
          <InvoiceResult searchResult={searchResult} search={search} isDialog />
        ) : null}
      </Box>
    </Dialog>
  );
}
